export function getLocale(): string {
  let _locale = ''

  if (global['locale'] !== undefined) {
    if (global['locale'] !== 'vn') {
      _locale = global['locale']
    }
  } else {
    if (typeof window !== 'undefined') {
      let { locale } = window['__NEXT_DATA__'].props
      if (locale !== 'vn') {
        _locale = locale
      }
    }
  }

  return _locale
}
